import React from "react";
import styled from "styled-components";
import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Color } from "../../../constants/color";

// L'avviso che l'elenco attestati non è completo. È una barra e non un toast
// perché la condizione dura finché dura: chi arriva sulla pagina dopo che il
// toast è sparito conterebbe attestati mancanti senza sapere che mancano.
// Sta sopra le tab perché riguarda tutte e quattro, non una ricerca sola.
const Barra = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  width: 100%;
  margin-bottom: 1rem;
  padding: 1rem 1.25rem;
  border: 1px solid ${Color.ORANGE};
  border-radius: 0.75rem;
  background-color: ${Color.LIGHT_YELLOW};
  text-align: left;

  & p.titolo {
    font-family: "Avenir Next Bold", sans-serif;
    font-weight: bold;
    color: ${Color.DARK_GREY};
  }

  & p.dettaglio {
    font-size: 0.95rem;
    color: ${Color.DARK_GREY};
    max-width: 90ch;
  }
`;

// Il testo dice le due cose che cambiano il lavoro di chi legge: l'elenco non
// è tutto, e quindi i conteggi sono per difetto. Del tetto di pagine del
// documentale non si parla: chi guarda è un operatore dell'azienda.
export function AvvisoListaIncompleta() {
  const { t } = useTranslation();
  return (
    <Barra role="status">
      <TriangleAlert color={Color.ORANGE} size={24} strokeWidth={2} />
      <div>
        <p className="titolo">{t("attestati-lista-incompleta-titolo")}</p>
        <p className="dettaglio">{t("attestati-lista-incompleta-dettaglio")}</p>
      </div>
    </Barra>
  );
}

export default AvvisoListaIncompleta;
